import React from 'react';
import cn from '@/utils/cn';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  filled?: boolean;
}

/** Shared label/value row used by both the scheduled payment and batch modals. */
const DetailRow: React.FC<DetailRowProps> = ({ label, value, filled }) => (
  <div
    className={cn(
      'flex min-h-[60px] items-center justify-between gap-x-4 rounded-lg px-4 py-4',
      filled ? 'bg-emerge-base-3' : 'bg-white'
    )}>
    <span className="whitespace-nowrap text-sm font-medium text-emerge-navy">{label}</span>
    <span className="text-right text-sm font-medium text-emerge-navy-2">{value}</span>
  </div>
);

export default DetailRow;
